import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getLatestPrograms } from '../store/reducers/programs';
import { AppDispatch, RootState } from '../store';
import CoachMark from '../interfaces/CoachMark';
import DashboardCoachMark from '../components/coach-mark/Dashboard';
import { User } from '../models/User';
import CalendarCoachMark from '../components/coach-mark/Calendar';
import HistoryCoachMark from '../components/coach-mark/History';
import UpcomingCoachMark from '../components/coach-mark/Upcoming';
import Greeting from '../components/shared/Greeting';
import UpcomingPanel from '../components/panels/Upcoming';
import OverviewWidget from '../widgets/overview/Overview';
import PendingTaskPanel from '../components/panels/PendingTask';
import { Link, Outlet } from 'react-router-dom';
import LatestProgrammes from '../components/program/components/LatestProgrammes';
import LatestProgrammmesCard from '../components/program/components/LatestProgrammmesCard';
import CoachMarks from '../components/coach-mark/CoachMarks';
import { getProfileData } from 'store/reducers/authentication';
import TodayEventCard from 'components/calendar/TodayEventCard';
import IEvent from 'models/Event';
import { fetchUpcomingEvents } from 'store/reducers/event';
import latest_program from '../assets/images/latest_program.png';
import pending_task from '../assets/images/pending_task.png';
import upcoming_panel from '../assets/images/upcoming_panel.png';

interface Props {
  events: IEvent[];
}

type ScheduledType = "Past" | "Today" | "Upcoming"



const Dashboard = () => {
  const [user, setUser] = useState<User>()
  const userState = useSelector((state: RootState) => state.auth.user as User);
  const { latestPrograms } = useSelector((state: RootState) => state.programs)
  const { items, isLoading } = useSelector((state: RootState) => state.events)
  const [scheduledType, setScheduledType] = useState<ScheduledType>("Today");
  const scheduledTypes: ScheduledType[] = ["Past", "Today", "Upcoming"];



  useEffect(() => {
    setUser(userState);
  }, [userState])


  const coachMarks: CoachMark[] = [
    {
      heading: "Dashboard",
      targetId: "dashboard-menu",
      content: <DashboardCoachMark />,
      headerAlignmentType: "top",
    },
    {
      heading: "Calendar",
      targetId: "calendar-menu",
      content: <CalendarCoachMark />,
      headerAlignmentType: "top",
    },
    {
      heading: "History",
      targetId: "history-menu",
      content: <HistoryCoachMark />,
      headerAlignmentType: "top",
    },
    {
      heading: "Upcoming Programmes",
      targetId: "upcoming-programme",
      content: <UpcomingCoachMark />,
      headerAlignmentType: "right",
    },
    // Add more coach marks as needed.
  ];

  const dispatch = useDispatch<AppDispatch>()

  useEffect(() => {
    dispatch(getLatestPrograms());
    dispatch(getProfileData());
    dispatch(fetchUpcomingEvents())

  }, []);

  const filterEvents = (filterType: ScheduledType) => {
    const currentDate = new Date();
    const todayStart = new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate());
    const todayEnd = new Date(todayStart.getTime() + 24 * 60 * 60 * 1000); // End of today




    switch (filterType) {
      // case "Past":
      //   return events.filter((event) => new Date(event.date) < todayStart);
      case "Today":
        return items.filter(
          (event) =>
            new Date(event.date).getDate() === currentDate.getDate() &&
            new Date(event.date).getMonth() === currentDate.getMonth() &&
            new Date(event.date).getFullYear() === currentDate.getFullYear()
        );
      // case "Upcoming":
      //   return events.filter((event) => new Date(event.date) > todayEnd);
      default:
        return items;
    }
  };

  const filteredEvents = filterEvents(scheduledType);
  const groupedEvents: { [monthYear: string]: { [date: string]: IEvent[] } } = {};
  filteredEvents.forEach((event) => {

    const monthYear = `${new Date(event.date).toLocaleString("default", { month: "long" })} ${new Date(event.date).getFullYear()}`;
    const date = `${new Date(event.date).getDate()}-${new Date(event.date).toLocaleString("default", { month: "short" })}-${new Date(event.date).getFullYear()}`;
    if (!groupedEvents[monthYear]) {
      groupedEvents[monthYear] = {};
    }
    if (!groupedEvents[monthYear][date]) {
      groupedEvents[monthYear][date] = [];
    }
    groupedEvents[monthYear][date].push(event);
  });

  return (
    <div className="grid grid-cols-4 mobile:grid-cols-1 tablet:grid-cols-1 
      grid-rows-[auto_1fr] mobile:grid-rows-[auto] tablet:grid-rows-[auto] 
      gap-4 w-full h-[85vh] mobile:h-auto tablet:h-auto 
      bg-[#F5F6FA] p-4 rounded-2xl">

      {/* Greeting */}
      <div className="col-span-3 row-start-1 
        mobile:col-span-1 tablet:col-span-1 
        mobile:order-1 tablet:order-1">
        {user?.name && <Greeting name={user.name} />}
      </div>

      {/* Join card mobile tablet*/}
      <div className="mobile:block tablet:block hidden mobile:order-2 tablet:order-2 mobile:row-auto tablet:row-auto">

        {/* Mobile */}
        <div className="block tablet:hidden laptop:hidden desktop:hidden largescreen:hidden xxl:hidden ml-4">
          {Object.keys(groupedEvents).map((monthYear) => (
            <div key={monthYear}>
              {Object.keys(groupedEvents[monthYear]).map((date) => (
                <div key={date}>
                  {groupedEvents[monthYear][date].map((event) => (
                    <TodayEventCard key={event.id} event={event} />
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>

        {/* Tablet */}
        <div className="hidden tablet:block laptop:hidden desktop:hidden largescreen:hidden xxl:hidden col-span-4">
          {Object.keys(groupedEvents).map((monthYear) => (
            <div key={monthYear}>
              {Object.keys(groupedEvents[monthYear]).map((date) => (
                <div key={date}>
                  {groupedEvents[monthYear][date].map((event) => (
                    <TodayEventCard key={event.id} event={event} />
                  ))}
                </div>
              ))}
            </div>
          ))}
        </div>
      </div>

      {/* Join card (Desktop only) */}
      <div className="col-span-1 row-span-2 row-start-1 h-full 
        mobile:hidden tablet:hidden">
        <div className="relative bg-[#F5F6FA] rounded-2xl p-4 h-full border border-[#E5E7EB] overflow-hidden">

          <img
            src={upcoming_panel}
            className="absolute bottom-0 left-0 w-full"
          />

          <div className="relative h-full flex flex-col min-h-0">
            <UpcomingPanel />
          </div>

        </div>
      </div>

      {/* Overview (Mobile/Tablet separate, Desktop inside left panel) */}
      <div className="hidden mobile:block tablet:block 
        mobile:order-2 tablet:order-2">
          <OverviewWidget />
      </div>

      {/* LEFT PANEL (Desktop only) */}
      <div className="col-span-2 row-start-2 h-full 
        mobile:hidden tablet:hidden">

        <div className="relative bg-[#F5F6FA] rounded-2xl p-4 h-full border border-[#E5E7EB] overflow-hidden">

          <img
            src={latest_program}
            className="absolute bottom-0 left-0 w-full"
          />

          <div className="relative flex flex-col h-full">

            <OverviewWidget />

            <div className="mt-3 flex flex-col flex-1 min-h-0">

              <div className="text-[#545455] font-semibold text-sm mb-2">
                MY PROGRAMMES
              </div>

              <div className="h-[1px] bg-[#D4D6DB] mb-2" />

              <div className="flex-1 overflow-y-auto">
                <LatestProgrammes data={latestPrograms || []} limit={4} />
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* 3. Pending Tasks */}
      <div className="col-span-1 row-start-2 h-full 
        mobile:order-3 tablet:order-3 
        mobile:col-span-1 tablet:col-span-1 mobile:row-auto tablet:row-auto">

        <div className="relative bg-[#F5F6FA] rounded-2xl p-4 h-full border border-[#E5E7EB] overflow-hidden">

          <img
            src={pending_task}
            className="absolute bottom-0 left-0 w-full"
          />

          <div className="relative h-full flex flex-col min-h-0">
            <PendingTaskPanel />
          </div>

        </div>
      </div>

      {/* 4. Latest Programmes (Mobile/Tablet only) */}
      <div className="hidden mobile:block tablet:block 
        mobile:order-4 tablet:order-4">

        <div className="bg-[#F5F6FA] rounded-2xl p-4 border border-[#E5E7EB] mb-10">

          <div className="text-[#545455] font-semibold text-sm mb-2">
            MY PROGRAMMES
          </div>

          <div className="h-[1px] bg-[#D4D6DB] mb-2" />

          <LatestProgrammmesCard
            data={latestPrograms || []}
            limit={5}
          />

        </div>
      </div>
    </div>
  );
};
export default Dashboard;